import { fetchFieldPins, createFieldPin, deleteFieldPin } from '../routines';

const initialAttributes = {
  pins: {},
  isLoading: false,
  error: false,
};

const initialState = {
  organization: { ...initialAttributes },
  account: { ...initialAttributes },
  contact: { ...initialAttributes },
  pipeline: { ...initialAttributes },
};

const fieldPinReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchFieldPins.TRIGGER: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          isLoading: true,
        },
      };
    }

    case fetchFieldPins.SUCCESS: {
      const { scope, response } = action.payload;
      const { data } = response;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          isLoading: false,
          pins: data,
        },
      };
    }

    case fetchFieldPins.FAILURE: {
      const { scope } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          isLoading: false,
          error: true,
        },
      };
    }

    case createFieldPin.SUCCESS: {
      const { scope, pin } = action.payload;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          pins: { ...state[scope].pins, [pin.customColumnPinId]: pin },
        },
      };
    }

    case deleteFieldPin.SUCCESS: {
      const { scope, pinId } = action.payload;
      const { [pinId]: omit, ...res } = state[scope].pins;
      return {
        ...state,
        [scope]: {
          ...state[scope],
          pins: res,
        },
      };
    }

    default:
      return state;
  }
};

export default fieldPinReducer;
